import { CloseIcon } from 'assets/icons/CloseIcon'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { createBatch } from 'features/fuelManagement/fuelManagementSlice'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { fuelTypes } from './fuelData'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'

export const AddBatchModal = ({ closeModal }: { closeModal: any }) => {
    const dispatch = useDispatch<AppDispatch>()
    const [state, setState] = useState<IFuelBatchModal>({
        fuelTank: null,
        fuelType: null,
        amount: 0,
        price: 0,
        supplier: null,
        date: new Date(),
    })

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, valueAsNumber, value } = e.target
        setState(prev => {
            const copy = { ...prev }
            copy[name] = name == 'supplier' ? value : valueAsNumber
            return copy
        })
    }

    const handleSave = async () => {
        if (!state.amount || !state.price || !state.supplier) {
            toast.warn('All fields are required.')
            return
        }
        await dispatch(createBatch(state))
        closeModal()
    }

    const handleDate = (date: Date, name: string) => {
        setState(prev => {
            const copy = { ...prev }
            copy[name] = date
            return copy
        })
    }

    const parse = (data: any) => {
        return data.data.map((item) => ({ label: item.name, value: item.id }))
    }

    const handleSelect = (value: ISelectValue, name: string) => {
        setState(prev => {
            const copy = { ...prev }
            copy[name] = value
            return copy
        })
    }

    return <Modal black>
        <Flex column end='true'>
            <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                <TitleText weight='bold' >Add a batch</TitleText>
                <CursorPointer onClick={closeModal} >
                    <CloseIcon />
                </CursorPointer>
            </Flex>
            <Input placeholder='Enter amount' labelText='Amount' value={state.amount} onChange={handleChange} type='number' name='amount' />
            <Input placeholder='Enter price' labelText='Price' value={state.price} onChange={handleChange} type='number' name='price' />
            <HonestSelectAsyncInput link='fuel/management/tank' name='fuelTank' labelText='Fuel Tank' onChange={handleSelect} parserFunction={parse} />
            <HonestSelectAsyncInput link='fuel/management/supplier' name='supplier' labelText='Fuel Supplier' onChange={handleSelect} parserFunction={parse} />
            <HonestSelectInput name='fuelType' labelText='Fuel Type' onChange={handleSelect} options={fuelTypes} />
            <CalendarInput name='date' labelText='Date' defaultValue={new Date(state.date)} onChange={handleDate} maxDate={new Date()} />
            <Flex width='100%' justcenter >
                <Button disabled={!state.amount || !state.price || !state.supplier} orange onClick={handleSave} >Save</Button>
            </Flex>
        </Flex>
    </Modal>
}

export interface IFuelBatchModal {
    fuelTank: ISelectValue
    fuelType: ISelectValue
    amount: number
    price: number
    supplier: ISelectValue
    date: Date
}